import { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import { useAirline } from "../context/AirlineContext";
import { resolveIcon } from "../shared/iconMap";
import PriceGate from "../shared/PriceGate";
import { AirlineSlideHead } from "../shared/AirlineSlideRenderers";

const SlideCathayCommercials = () => {
  const { isDark } = useTheme();
  const { airline } = useAirline();
  const brand = airline.brandColor || "#005D63";
  const c = airline?.content?.commercials || {};
  const blocks = c.blocks || [];
  const [activeBlock, setActiveBlock] = useState(null);

  return (
    <PriceGate accentColor={brand} isDark={isDark}>
      {({ revealed, Toggle, lockedNode }) => (
        <div>
          <AirlineSlideHead
            eyebrow="Commercials"
            title="A modular"
            accentLine="commercial framework."
            airline={airline}
            accent={brand}
            action={Toggle}
          />
          <p className={`k-lead max-w-[54ch] ${isDark ? "text-white/70" : "text-black/60"}`}>
            {c.subheading}
          </p>

          {!revealed ? (
            <div className="mt-10">{lockedNode}</div>
          ) : (
            <>
              <div className={`mt-12 pt-8 border-t grid grid-cols-3 gap-6 ${isDark ? "border-white/10" : "border-black/10"}`}>
                {blocks.map((block) => {
                  const Icon = resolveIcon(block.iconName);
                  const color = block.color === "brand" ? brand : block.color;
                  const isActive = activeBlock === block.id;
                  return (
                    <div
                      key={block.id}
                      onClick={() => setActiveBlock(isActive ? null : block.id)}
                      data-testid={`commercial-block-${block.id}`}
                      className={`rounded-2xl p-6 border cursor-pointer transition-all ${
                        isDark
                          ? isActive ? "bg-white/[0.06]" : "bg-white/[0.03] border-white/10 hover:bg-white/[0.06]"
                          : isActive ? "bg-white" : "bg-white border-black/10 hover:border-black/25"
                      }`}
                      style={isActive ? { borderColor: color, boxShadow: `0 12px 40px -20px ${color}` } : undefined}
                    >
                      <div className="flex items-center gap-2 mb-3">
                        <Icon className="w-5 h-5" style={{ color }} />
                        <div className="k-eyebrow" style={{ color }}>{block.title}</div>
                      </div>
                      <div className={`text-[32px] font-semibold tracking-tight mb-1 ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
                        {block.total}
                        <span className={`text-[15px] font-normal ml-1 ${isDark ? "text-white/50" : "text-black/50"}`}>{block.totalSuffix}</span>
                      </div>
                      <ul className={`mt-5 divide-y ${isDark ? "divide-white/10" : "divide-black/10"}`}>
                        {block.items.map((item, i) => (
                          <li key={i} className="py-3 flex items-center justify-between gap-3">
                            <span className={`text-[13px] ${isDark ? "text-white/75" : "text-black/70"}`}>{item.name}</span>
                            <span className="text-[13px] font-semibold" style={{ color }}>{item.amount}</span>
                          </li>
                        ))}
                      </ul>
                    </div>
                  );
                })}
              </div>
              <div className={`mt-8 text-center text-[13px] italic ${isDark ? "text-white/45" : "text-black/45"}`}>
                {c.footNote}
              </div>
            </>
          )}
        </div>
      )}
    </PriceGate>
  );
};

export default SlideCathayCommercials;
